<template>
    <VanBtn round class="linear-gradient-btn">
        <slot></slot>
    </VanBtn>
</template>

<script>
    import { Button as VanBtn } from 'vant';
    export default {
        name: 'LinearGradientBtn',
        components:{
            VanBtn
        }
    }
</script>

<style lang="scss" scoped>
    .linear-gradient-btn{
        color: #fff;
        background: linear-gradient(to left, #FC7D13, #FFA207)
    }
</style>
